import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import typography from "./Typography";
import { shadows } from "./Shadows";

let baseTheme = createTheme({
  palette: {
    primary: {
      main: '#5D87FF',
      light: '#ECF2FF',
      dark: '#4570EA',
    },
    secondary: {
      main: '#49BEFF',
      light: '#1fbeb2',
      dark: '#23afdb',
    },
    success: {
      main: '#10B981',
      light: '#D1FAE5',
      dark: '#059669',
      contrastText: '#ffffff',
    },
    info: {
      main: '#539BFF',
      light: '#EBF3FE',
      dark: '#005ea5',
      contrastText: '#ffffff',
    },
    error: {
      main: '#FA896B',
      light: '#FDEDE8',
      dark: '#ac1c00',
      contrastText: '#ffffff',
    },
    warning: {
      main: '#FFAE1F',
      light: '#FEF5E5',
      dark: '#e28800',
      contrastText: '#ffffff',
    },
    purple: {
      A50: '#EBF3FE',
      A100: '#6610f2',
      A200: '#557fb9',
    },
    grey: {
      100: '#F2F6FA',
      200: '#EAEFF4',
      300: '#d4d4d4',
      400: '#7C8FAC',
      500: '#5A6A85',
      600: '#2A3547',

    },
    text: {
      primary: '#2A3547',
      secondary: '#5A6A85',
      hint: '#595959',
      contrast: '#f6f9fc',
      contrastPrimary: '#007b11'
    },
    action: {
      disabledBackground: 'rgba(73,82,88,0.12)',
      hoverOpacity: 0.02,
      hover: '#f6f9fc',
    },
    background: {
      auth: 'radial-gradient(#d2f1df, #d3d7fa, #bad8f4)',
    },
    divider: '#e5eaef',
  },
      breakpoints: {
        values: {
          xs: 0,
          sm: 600,
          md: 960,
          lg: 1280,
          xl: 1920,
        },
      },
  typography,
  shadows
});

// Автоматически делает все шрифты адаптивными для разных размеров экрана
baseTheme = responsiveFontSizes(baseTheme);

export { baseTheme };
